import { Component, forwardRef, Input, OnDestroy, OnInit } from '@angular/core';
import {
  ControlValueAccessor,
  FormBuilder,
  FormControl,
  FormGroup,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  Validators,
} from '@angular/forms';
import { Subscription } from 'rxjs';

import { IdName } from '@core/model/id-name';
import { RapiPhoneComponent } from '../rapi-phone/rapi-phone.component';

@Component({
  selector: 'app-rapi-radio-group',
  templateUrl: './rapi-radio-group.component.html',
  styleUrls: ['./rapi-radio-group.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RapiRadioGroupComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => RapiRadioGroupComponent),
      multi: true,
    },
  ],
})
export class RapiRadioGroupComponent implements OnInit, ControlValueAccessor, OnDestroy {
  @Input('values') values: IdName[];
  @Input('label') label: string;
  @Input('disabled') disabled: boolean = false;
  subscriptions: Subscription[] = [];
  form: FormGroup;

  constructor(private formBuilder: FormBuilder) {
    this.form = this.formBuilder.group({
      radio: ['', Validators.required],
    });
    if (this.form.controls['radio'].value != null && this.form.controls['radio'].value != 'undefined') {
      this.form.controls['radio'].markAsTouched({ onlySelf: true });
    }

    this.subscriptions.push(
      this.form.valueChanges.subscribe((value) => {
        this.onChange(value.radio);
        this.onTouched();
      })
    );

    this.form.controls['radio'].statusChanges.subscribe((status) => {
      this.form.updateValueAndValidity();
    });
  }

  ngOnInit() {}

  ngOnDestroy(): void {}

  onChange: any = () => {};
  onTouched: any = () => {};

  get value(): IdName {
    return this.form.value;
  }

  set value(value: IdName) {
    this.form.setValue(value);
    this.onChange(value);
    this.onTouched();
  }

  writeValue(value: IdName): void {
    if (value) {
      this.value = value;
    }

    if (value === null) {
      this.form.reset();
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {}

  validate(_: FormControl) {
    return this.form.valid ? null : { radio: { valid: false } };
  }
}
